export default __webpack_public_path__ + "static/media/tiktok.4f9d9bb6.svg";